import React from "react";

export const Title = () => {
  return (
    <div className="title-body">
      <h1>Weather App</h1>
      <h5>Find out the status of the weather in different countries </h5>
    </div>
  );
};
export default Title;
